import { render } from "./GlitchH1.vue?vue&type=template&id=2d479ad9&scoped=true&ts=true"
import script from "./GlitchH1.vue?vue&type=script&lang=ts"
export * from "./GlitchH1.vue?vue&type=script&lang=ts"

import "./GlitchH1.vue?vue&type=style&index=0&id=2d479ad9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d479ad9"]])

export default __exports__